import { render } from "./CircleDiagram.vue?vue&type=template&id=5b81beed"
import script from "./CircleDiagram.vue?vue&type=script&lang=js"
export * from "./CircleDiagram.vue?vue&type=script&lang=js"

import "./CircleDiagram.vue?vue&type=style&index=0&id=5b81beed&lang=css"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__